import { ReactElement } from 'react';
import { BaseIcon, BaseIconProps } from '../BaseIcon';

export const IntegrateIcon = ({ ...props }: Omit<BaseIconProps, 'children'>): ReactElement => (
  <BaseIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.207 15.293a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414l3-3a1 1 0 0 1 1.414 0ZM16.707 4.293a1 1 0 0 1 0 1.414l-2.5 2.5a1 1 0 1 1-1.414-1.414l2.5-2.5a1 1 0 0 1 1.414 0ZM20.207 7.793a1 1 0 0 1 0 1.414l-2.5 2.5a1 1 0 0 1-1.414-1.414l2.5-2.5a1 1 0 0 1 1.414 0Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m11 4.086 9.414 9.414-3.171 3.172a6 6 0 0 1-8.486 0l-.929-.93a6 6 0 0 1 0-8.485L11 4.086Zm0 2.828L9.243 8.672a4 4 0 0 0 0 5.656l.929.93a4 4 0 0 0 5.656 0l1.758-1.758L11 6.914Z"
    />
  </BaseIcon>
);

IntegrateIcon.displayName = 'IntegrateIcon';
